<template>
  <div class="page__single page__datenschutz">
    <div class="container">
      <div class="row">
        <div class="col-12 text-left">
          <template v-if="lang == 'DE'">
            <h1>Datenschutzerklärung</h1>
            <div class="entry-content">

              <h3 class="font-weight-bold mt-5">1. Verantwortlich im datenschutzrechtlichen Sinne</h3>



              <p><strong>Albert-Ludwigs-Universität Freiburg</strong><br>Friedrichstraße 39<br>79098 Freiburg<br>++49 (0)761/203-0<br><a href="mailto:info@uni-freiburg.de">info@uni-freiburg.de</a></p>



              <h3 class="font-weight-bold mt-5">2. Datenschutzbeauftragter</h3>



              <p>Albert-Ludwigs-Universität Freiburg<br>Der Datenschutzbeauftragte<br>Fahnenbergplatz<br>79085 Freiburg<br><a href="mailto:datenschutzbeauftragter@uni-freiburg.de">datenschutzbeauftragter@uni-freiburg.de</a></p>



              <h3 class="font-weight-bold mt-5">3. Hinweis vorab</h3>



              <p>Diese Informationen zum Datenschutz (Datenschutzerklärung) beziehen sich auf den zentralen Webauftritt der Universität Freiburg (www.uni-freiburg.de), der technisch vom Rechenzentrum der Universität Freiburg betrieben wird. Daneben gibt es weitere Webauftritte und Webserver von Instituten und Fakultäten, welche ggf. anders mit personenbezogenen Daten umgehen und entsprechend andere Datenschutzerklärungen haben.</p>



              <p>Generell nehmen wir die Privatsphäre der Besucherinnen und Besucher sehr ernst und erheben nur erforderliche Daten, um die Funktionalität und Bedienbarkeit der Webseiten zu optimieren.</p>



              <p>Soweit die Verarbeitung von personenbezogenen Daten zur Erfüllung der in der Zuständigkeit der Universität Freiburg liegenden Aufgabe oder einer Aufgabe, die im öffentlichen Interesse liegt, erforderlich ist, erfolgt die Verarbeitung auf der Grundlage von Art. 6 Abs. 1 lit. e, Abs. 3 EU-Datenschutzgrundverordnung (DSGVO) in Verbindung mit § 4 Landesdatenschutzgesetz.</p>



              <p>Dazu hat die Universität im Bereich der Außendarstellung sowie Presse- und Öffentlichkeitsarbeit, insbesondere beim Betrieb von Webseiten, ein berechtigtes Interesse an der Verarbeitung bestimmter personenbezogener Daten der Nutzer:innen und Besucher:innen ihrer Angebote.</p>



              <h3 class="font-weight-bold mt-5">4. Erhebung personenbezogener Daten</h3>



              <p>Soweit nicht auf den jeweiligen Webseiten besonders ausgeführt, werden personenbezogene Daten wie folgt erhoben:</p>



              <h3 class="font-weight-bold mt-5">4.1. Bereitstellung der Webseite und Erstellung von Logfiles</h3>



              <h3 class="font-weight-bold mt-5">4.1.1. Beschreibung und Kategorien von Daten</h3>



              <p>Wenn Sie diese oder andere Internetseiten aufrufen, übermitteln Sie über Ihren Browser Daten an unseren Webserver. Die folgenden Daten werden während einer laufenden Verbindung ausschließlich im Fehlerfall temporär in einer Logdatei aufgezeichnet:</p>



              <ul><li>IP-Adresse des anfragenden Rechners</li><li>Datum und Uhrzeit des Zugriffs</li><li>Name, URL und übertragene Datenmenge zu der angefragten Datei</li><li>Zugriffsstatus (angeforderte Datei übertragen, nicht gefunden etc.)</li><li>Browsertyp und Betriebssystem (sofern vom anfragenden Webbrowser übermittelt)</li><li>Webseite, von der aus der Zugriff erfolgte (sofern vom anfragenden Webbrowser übermittelt)</li></ul>



              <p>Die Verarbeitung der Daten in dieser Logdatei geschieht wie folgt:</p>



              <ul><li>In Einzelfällen, d.h. bei gemeldeten Störungen, Fehlern und Sicherheitsvorfällen, erfolgt eine manuelle Analyse.</li></ul>



              <h3 class="font-weight-bold mt-5">4.1.2. Zweck</h3>



              <p>Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der Website an den Rechner des:der Nutzers:in zu ermöglichen. Hierfür muss die IP-Adresse des:der Nutzers:in für die Dauer der Sitzung gespeichert bleiben.<br>Die Speicherung in einer Logdatei erfolgt, um die Funktionsfähigkeit der Website sicherzustellen. Zudem dienen uns die Daten zur Optimierung der Website und zur Sicherstellung der Sicherheit unserer informationstechnischen Systeme. Die in den Logeinträgen enthaltenen IP-Adressen werden nicht mit anderen Datenbeständen zusammengeführt, es sei denn, es liegen tatsächliche Anhaltspunkte für eine Störung des ordnungsgemäßen Betriebs vor.<br>In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung nach Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.1.3. Rechtsgrundlage</h3>



              <p>Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.1.4. Empfänger</h3>



              <p>Sofern wegen Angriffen auf unsere informationstechnischen System Ermittlungsmaßnahmen eingeleitet werden, können die oben unter 4.1. genannten Daten bzw. Logdateien an staatliche Ermittlungsorgane (z.B. Polizei, Staatsanwaltschaft) weitergegeben werden.<br>Dasselbe gilt, wenn entsprechende Behörden oder Gerichte Anfragen an die Universität richten und die Universität dazu verpflichtet ist, diesen Folge zu leisten.</p>



              <h3 class="font-weight-bold mt-5">4.1.5. Dauer der Speicherung</h3>



              <p>Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist.<br>Die Speicherung der Daten in Logdateien werden nach sieben Tagen gelöscht.</p>



              <h3 class="font-weight-bold mt-5">4.1.6. Folgen der Nichtangabe, Widerspruchs- bzw. Beseitigungsmöglichkeit</h3>



              <p>Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Nutzer:innen, die nicht möchten, dass ihre Daten wie beschrieben verarbeitet werden, können sich über Alternativwege (telefonisch, schriftlich, persönlich) an die Universität wenden, um entsprechende Informationen zu erhalten oder Vorgänge durchzuführen.</p>



              <h3 class="font-weight-bold mt-5">4.2. Nutzung von Cookies</h3>



              <h3 class="font-weight-bold mt-5">4.2.1. Beschreibung und Kategorien von Daten</h3>



              <p>Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die vom Internetbrowser auf dem Computersystem des:der Nutzers:in gespeichert werden. Ruft ein:eine Nutzer:in eine Website auf, so kann ein Cookie auf dem Computersystem des:der Nutzers:in gespeichert werden. Ein Cookie kann z.B eine charakteristische Zeichenfolge enthalten, die eine eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht.<br>Folgende Daten werden auf diesem Webauftritt in Cookies gespeichert und übermittelt:</p>



              <figure class="wp-block-table is-style-regular"><table><thead><tr><th>Ursprung</th><th>Name</th><th>Inhalt (Beispiel)</th><th>Zweck</th><th>Gültigkeit</th></tr></thead><tbody><tr><td>uni-freiburg.de</td><td>serverid</td><td>p4wn15-4</td><td>Loadbalancer-Zuordnung</td><td>Bis zum Sitzungsende des Browsers</td></tr><tr><td>videoportal.uni-freiburg.de</td><td>framework</td><td>kfaosr57pe1i31es2282u9q3v5</td><td>Session-ID</td><td>7 Tage</td></tr><tr><td>videoportal.uni-freiburg.de</td><td>cookieAccepted</td><td>1</td><td>Cookies vom Besuchenden erlaubt</td><td>10 Jahre</td></tr></tbody></table></figure>



              <p>Nähere Informationen zu einzelnen Funktionen, die Cookies nutzen (Videoportal), erhalten Sie unter der jeweiligen Überschrift in dieser Erklärung.</p>



              <h3 class="font-weight-bold mt-5">4.2.2. Zweck</h3>



              <p>Der Zweck der Verwendung der unter 4.2.1 genannten technisch notwendigen Cookies ist, die Nutzung von Websites für die Nutzer:innen zu vereinfachen. Einige Funktionen unserer Internetseite können ohne den Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der Browser auch nach einem Seitenwechsel wiedererkannt wird.</p>



              <p>Die Zwecke pro Cookie sehen Sie in der Tabelle unter 4.2.1.</p>



              <p>Die durch die Cookies erhobenen Nutzerdaten werden nicht zur Erstellung von Nutzerprofilen verwendet.</p>



              <p>In diesen Zwecken liegt auch unser berechtigtes Interesse in der Verarbeitung der personenbezogenen Daten nach Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.2.3. Rechtsgrundlage</h3>



              <p>Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies ist Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.2.4. Empfänger</h3>



              <p>Empfänger der in den Cookies enthaltenen Informationen ist ausschließlich der berechtigte Webserver, d.h. der den Cookie setzende Webserver der Universität.</p>



              <h3 class="font-weight-bold mt-5">4.2.5. Dauer der Speicherung</h3>



              <p>Die Speicherdauer der Cookies finden Sie in der Tabelle unter 4.2.1.</p>



              <p>Da die Cookies auf Ihrem Endgerät gespeichert sind, haben Sie auch die Möglichkeit einer früheren Löschung. Näheres erfahren Sie im nachstehenden Punkt.</p>



              <h3 class="font-weight-bold mt-5">4.2.6. Folgen der Nichtangabe, Widerspruchs- bzw. Beseitigungsmöglichkeit</h3>



              <p>Cookies werden auf dem Rechner der Besucher:innen gespeichert und von diesem an unserer Seite übermittelt. Daher haben Sie als Nutzer:in – unabhängig von den vorstehend aufgeführten Speicherfristen – auch die volle Kontrolle über die Verwendung von Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für unseren Webauftritt deaktiviert, können möglicherweise nicht mehr alle Funktionen der Website vollumfänglich genutzt werden.</p>



              <h3 class="font-weight-bold mt-5">4.3. Nutzung von Matomo</h3>



              <p>Auf unserer Webseite wird Matomo zur Analyse des Nutzungsverhaltens unserer Besucher:innen eingesetzt. Matomo erfasst unter anderem Daten, von welcher Webseite aus eine betroffene Person auf unsere Webseite gekommen ist, auf welche Unterseiten der Webseite zugegriffen wurde, die Verweildauer auf einer Webseite oder die Häufigkeit des Aufrufs der Webseite.</p>



              <p>Ihre IP-Adresse, über die Sie auf unsere Webseite zugreifen, wird anonymisiert. Matomo ist so eingestellt, dass 2 Bytes der IP-Adresse maskiert werden (Bsp.: 192.168.xxx.xxx). Auf diese Weise ist eine Zuordnung der gekürzten IP-Adresse zum aufrufenden Rechner nicht mehr möglich.</p>



              <p>Matomo ist weiterhin so eingerichtet, dass zur Analyse der Webseiten-Nutzung keine Cookies gesetzt werden.</p>



              <p>Die von Matomo erhobenen Nutzungsinformationen werden ausschließlich auf Servern der Universität Freiburg gespeichert. Die gespeicherten Nutzungsdaten werden nicht an Dritte weitergegeben. Eine Zusammenführung dieser Daten mit ggf. weiteren gespeicherten Daten, wie sie bei Inanspruchnahme anderer Angebote verbunden mit der Angabe von persönlichen Daten entstehen, findet nicht statt.</p>



              <p>Die Analyse des Nutzungsverhaltens unserer Besucher:innen hilft uns bei der Optimierung unserer Angebote und der Verbesserung der Nutzungsfreundlichkeit der Webseite. Hier liegt unser berechtigtes Interesse in der Verarbeitung der Daten nach Art. 6 Abs. 1 (f) DSGVO.<br>Durch die Anonymisierung der IP-Adresse und der Vermeidung von Cookies wird dem Interesse der Nutzer:innen am Schutz ihrer personenbezogenen Daten hinreichend Rechnung getragen.</p>



              <p>Zudem bieten wir unseren Nutzern:innen auf unserer Webseite die Möglichkeit eines Opt-Out aus dem Analyseverfahren. In diesem Fall wird durch Matomo ein Cookie auf ihrem System gespeichert, der Matomo signalisiert keine Nutzungsdaten zu erheben. Dieser Cookie wird nicht zur Analyse der Webseiten-Nutzung verwendet. Hinweis: Wenn Sie generell Ihre Cookies löschen, muss der Opt-Out-Cookie erneut aktiviert werden.</p>



              <p>Nähere Informationen zu den Privatsphäreeinstellungen der Matomo Software finden Sie unter folgendem Link: <a href="https://matomo.org/docs/privacy" target="_blank" rel="noreferrer noopener">https://matomo.org/docs/privacy</a>.</p>



              <h3 class="font-weight-bold mt-5">4.3.1. Beschreibung und Kategorien von Daten</h3>



              <p>Werden Einzelseiten unserer Website aufgerufen, so werden folgende Daten gespeichert:</p>



              <ol><li>Zwei Bytes der IP-Adresse des aufrufenden Systems des Nutzers (Die Software ist so eingestellt, dass die IP-Adressen nicht vollständig gespeichert werden, sondern 2 Bytes der IP-Adresse maskiert werden (Bsp.: 192.168.xxx.xxx). Auf diese Weise ist eine Zuordnung der gekürzten IP-Adresse zum aufrufenden Rechner nicht mehr möglich.)</li><li>Die aufgerufene Webseite</li><li>Die Website, von der der Nutzer auf die aufgerufene Webseite gelangt ist (Referrer)</li><li>Die Unterseiten, die von der aufgerufenen Webseite aus aufgerufen werden</li><li>Die Verweildauer auf der Webseite</li><li>Die Häufigkeit des Aufrufs der Webseite</li></ol>



              <p>Die Software läuft ausschließlich auf den Servern der Universität. Eine Speicherung der Daten der Nutzer:innen findet nur dort statt. Eine Weitergabe der Daten an Dritte erfolgt nicht.<br>Personenbezogene Daten werden nur insofern temporär verarbeitet als die vollständige IP-Adresse bis zur Speicherung im flüchtigen Speicher verarbeitet wird.</p>



              <h3 class="font-weight-bold mt-5">4.3.2. Zweck</h3>



              <p>Die Verarbeitung der personenbezogenen Daten der Nutzer:innen ermöglicht uns eine Analyse des Nutzungsverhaltens unserer Besucher:innen. Wir sind durch die Auswertung der gewonnen Daten in der Lage, Informationen über die Nutzung der einzelnen Komponenten unserer Webseite zusammenzustellen. Dies hilft uns dabei unsere Webseite und deren Nutzerfreundlichkeit stetig zu verbessern. In diesen Zwecken liegt auch unser berechtigtes Interesse in der Verarbeitung der Daten nach Art. 6 Abs. 1 lit. f DS-GVO. Durch die Anonymisierung der IP-Adresse und der Vermeidung von Cookies wird dem Interesse der Nutzer:innen an deren Schutz personenbezogener Daten hinreichend Rechnung getragen.</p>



              <h3 class="font-weight-bold mt-5">4.3.3. Rechtsgrundlage</h3>



              <p>Rechtsgrundlage für die bis zur Speicherung der verkürzten IP-Adresse temporäre Verarbeitung der personenbezogenen Daten der Nutzer ist Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.3.4. Empfänger</h3>



              <p>Da keine personenbezogenen Daten erhoben werden, gibt es dafür keinen Empfänger.</p>



              <h3 class="font-weight-bold mt-5">4.3.5. Dauer der Speicherung</h3>



              <p>Es findet keine dauerhafte Speicherung personenbezogener Daten statt.</p>



              <h3 class="font-weight-bold mt-5">4.3.6. Folgen der Nichtangabe, Widerspruchs- bzw. Beseitigungsmöglichkeit</h3>



              <p>Unsere Website berücksichtigt die „Do Not Track“-Einstellung in Ihrem Browser. Sofern Ihr Browser keine „Do Not Track“-Einstellung bietet und Sie mit der Speicherung und Auswertung Ihrer Zugriffsdaten durch Matomo nicht einverstanden sind, klicken Sie den folgenden Link, um den Matomo-Deaktivierungs-Cookie in Ihrem Browser abzulegen.<br>Ihr aktueller Status:</p>



              <iframe style="border: 0; height: 150px; width: 100%;" src="https://piwik.mw.uni-freiburg.de/central/index.php?module=CoreAdminHome&amp;action=optOut&amp;idsite=22&amp;language=de"></iframe>



              <p>Achtung: Wenn Sie Ihre Cookies löschen, so hat dies zur Folge, dass auch der Opt-Out-Cookie gelöscht wird und ggf. von Ihnen erneut aktiviert werden muss.</p>



              <h3 class="font-weight-bold mt-5">4.4. VIMP / Videoportal der Universität Freiburg</h3>



              <h3 class="font-weight-bold mt-5">4.4.1. Beschreibung und Kategorien von Daten</h3>



              <p>Auf unserem Webauftritt werden Videos vom Videoportal der Universität Freiburg eingebunden und mit einem Player dargestellt. Wenn Sie eine Seite mit solch einer Video-Einbindung aufrufen, werden die in 4.1. genannten Cookies verwendet.</p>



              <h3 class="font-weight-bold mt-5">4.4.2. Zweck</h3>



              <p>Unsere Internetseiten sollen Ihnen die notwendigen Informationen bieten und medial ansprechend zu nutzen sein. Dazu gehört auch die Einbindung von Videos.<br>In diesen Zwecken liegt auch unser berechtigtes Interesse in der Verarbeitung der Daten nach Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.4.3. Rechtsgrundlage</h3>



              <p>Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten der Nutzer ist Art. 6 Abs. 1 lit. f DS-GVO.</p>



              <h3 class="font-weight-bold mt-5">4.4.4. Empfänger</h3>



              <p>Die Daten werden vom Cookie setzenden Server video.uni-freiburg.de genutzt.</p>



              <h3 class="font-weight-bold mt-5">4.4.5. Dauer der Speicherung</h3>



              <p>Siehe 4.1.</p>



              <h3 class="font-weight-bold mt-5">4.4.6. Folgen der Nichtangabe, Widerspruchs- bzw. Beseitigungsmöglichkeit</h3>



              <p>Wenn Sie die Nutzung von Videos des Videoportals der Universität nicht wünschen, können Sie die entsprechenden Webseiten, die Videos eingebunden haben, nicht nutzen.</p>



              <h3 class="font-weight-bold mt-5">4.5. Datenschutzerklärungen zu Social Media</h3>



              <ul><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/facebook">Facebook</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/twitter">Twitter</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/instagram">Instagram</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/youtube">Youtube</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/xing">Xing</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/linkedin">LinkedIn</a></li></ul>



              <p></p>



              <h3 class="font-weight-bold mt-5">5. Ihre Rechte</h3>



              <p>Sie haben das Recht, von der Universität Freiburg Auskunft über die zu Ihrer Person gespeicherten Daten zu erhalten und/oder unrichtig gespeicherte Daten berichtigen zu lassen.</p>



              <p>Sie haben darüber hinaus das Recht auf Löschung oder auf Einschränkung der Verarbeitung oder ein Widerspruchsrecht gegen die Verarbeitung.</p>



              <p>Außerdem haben Sie in dem Fall, in dem Sie uns eine Einwilligung zur Verarbeitung Ihrer personenbezogener Daten erteilt haben, das Recht, die Einwilligung jederzeit zu widerrufen, wobei die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt wird. Bitte wenden Sie sich dazu an <a href="mailto:datenschutz@uni-freiburg.de">datenschutz@uni-freiburg.de</a>. Sofern die Datenverarbeitung auf einer Einwilligung oder auf einem Vertrag beruht, weisen wir Sie an der entsprechenden Stelle darauf hin.</p>



              <p>Erfolgt die Datenverarbeitung zudem mithilfe automatisierter Verfahren, steht Ihnen gegebenenfalls ein Recht auf Datenübertragbarkeit zu (Art. 20 DS-GVO).</p>



              <p>Sie haben das Recht auf Beschwerde bei einer Aufsichtsbehörde, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die Rechtsvorschriften verstößt. Eine solche Aufsichtsbehörde ist beispielsweise der <a href="http://www.baden-wuerttemberg.datenschutz.de/" target="_blank" rel="noreferrer noopener">Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg</a>.</p>
            </div>

          </template>
          <template v-else-if="lang == 'EN'">
            <div class="entry-content">

              <h3 class="font-weight-bold mt-5">1. <strong>Responsible institution for data protection purposes</strong></h3>



              <p><strong>Albert-Ludwigs-Universität Freiburg</strong><br>Friedrichstraße 39<br>79098 Freiburg<br>Germany<br>++49 (0)761/203-0<br><a href="mailto:info@uni-freiburg.de">info@uni-freiburg.de</a></p>



              <h3 class="font-weight-bold mt-5">2. <strong>Data protection officer</strong></h3>



              <p>University of Freiburg<br>Data protection officer<br><a href="mailto:datenschutzbeauftragter@uni-freiburg.de">datenschutzbeauftragter@uni-freiburg.de</a></p>



              <h3 class="font-weight-bold mt-5">3. <strong>Note</strong></h3>



              <p>This information on data protection/data protection declaration refers to the central website of the University of Freiburg (www.uni-freiburg.de), which is operated by the IT Services Department of the University of Freiburg. Other websites and web servers operated by departments and faculties of the university may have their own policies for dealing with personal data and therefore have other data protection declarations.<br><br>In general terms, we take the private sphere of our visitors very seriously and collect only data that are necessary for optimizing the functionality and usability of the web pages.</p>



              <p>Insofar as the processing of personal data is necessary within the context of tasks lying within the responsibility of the University of Freiburg or a task&nbsp; that is in the public interest, the processing is conducted on the basis of § 6 para. 1 lit. e of the EU General Data Protection Regulation (EU-GDPR) in conjunction with § 4 of the State Data Protection Act.<br><br>In addition, the university has a legitimate interest in processing certain personal data of users and visitors in areas concerning its public image as well as for press work and public relations, particularly with regard to the operation of websites.</p>



              <h3 class="font-weight-bold mt-5">4. <strong>Collection of personal data</strong></h3>



              <p>Unless otherwise specified on the particular web pages, personal data are collected as follows:</p>



              <h3 class="font-weight-bold mt-5">4.1. <strong>Availability of web pages and creation of log files</strong></h3>



              <h3 class="font-weight-bold mt-5">4.1.1. <strong>Description and categories of data</strong></h3>



              <p>When you visit this or other web pages, you send data to our web server via your web browser. The following data are retained temporarily in a log file during an ongoing connection only in the case of an error:</p>



              <ul><li>IP address of the requesting computer</li><li>Date and time of the access</li><li>Name, URL, and amount of transferred data from the requested file</li><li>Access status (requested file transferred, not found, etc.)</li><li>Browser type and operating system (if sent by the requesting web browser)</li><li>Web page from which access was obtained (if sent by the requesting web browser)</li></ul>



              <p>The data in this log file are processed as follows:</p>



              <ul><li>In individual cases, i.e., reported defects, errors, and security incidents, a manual analysis is conducted.</li></ul>



              <h3 class="font-weight-bold mt-5">4.1.2. <strong>Purpose</strong></h3>



              <p>The system needs to temporarily store the user’s IP address to enable the website to be sent to the user’s computer. The user’s IP address must be retained for the duration of the session.<br>The data are stored in a log file as a means of ensuring the proper functioning of the website. In addition, we use the data to optimize the website and guarantee the security of our information technology systems. The IP addresses included in the log entries are not combined with other retained data unless there are actual indications that there has been a disruption of proper operation.<br>These purposes also constitute our legitimate interest in processing data in accordance with § 6 para. 1 lit. f GDPR (General Data Protection Regulation).</p>



              <h3 class="font-weight-bold mt-5">4.1.3. <strong>Legal basis</strong></h3>



              <p>The legal basis for the temporary retention of the data and the log files is § 6 para. 1 lit. f GDPR.</p>



              <h3 class="font-weight-bold mt-5">4.1.4. <strong>Recipient</strong></h3>



              <p>In the case that investigative measures are initiated due to attacks on our information technology system, the data and log files named above under 4.1. may be passed on to state investigative bodies (e.g., police, public prosecutor).<br>The same applies if these bodies or courts direct inquiries at the university and the university is obligated to comply with them.</p>



              <h3 class="font-weight-bold mt-5">4.1.5. <strong>Duration of data retention</strong></h3>



              <p>The data are deleted as soon as they are no longer needed to achieve the purpose for which they were collected. In the case of data collected to make the website available, this is the case at the end of the relevant session.<br>The data retained in log files are deleted after seven days.</p>



              <h3 class="font-weight-bold mt-5">4.1.6. <strong>Consequences of nondisclosure, possibility of objection or removal</strong></h3>



              <p>The collection of data for the purpose of making the website available and the storage of the data in log files is absolutely necessary for the operation of the website. Users who do not want their data to be processed as described may contact the university in other ways (by telephone, in writing, in person) to obtain information or perform functions available on the website.</p>



              <h3 class="font-weight-bold mt-5">4.2. <strong>Use of cookies</strong></h3>



              <h3 class="font-weight-bold mt-5">4.2.1. <strong>Description and categories of data</strong></h3>



              <p>Our website uses cookies. Cookies are text files stored on the user’s computer system by the internet browser. If a user calls up a website, a cookie can be stored on the user’s computer system. A cookie can include, e.g., a characteristic character string that enables the site to identify the browser when the user again calls up the website.</p>



              <p>The following data are stored in cookies and sent to the user’s computer system by this website:</p>



              <figure class="wp-block-table is-style-regular"><table><thead><tr><th>Ursprung</th><th>Name</th><th>Inhalt (Beispiel)</th><th>Zweck</th><th>Gültigkeit</th></tr></thead><tbody><tr><td>uni-freiburg.de</td><td>serverid</td><td>p4wn15-4</td><td>Load balancer classification</td><td>classification<br>Until the end of the browser session</td></tr><tr><td>videoportal.uni-freiburg.de</td><td>framework</td><td>kfaosr57pe1i31es2282u9q3v5</td><td>Session-ID</td><td>7 days</td></tr><tr><td>videoportal.uni-freiburg.de</td><td>cookieAccepted</td><td>1</td><td>Cookies from visitor allowed</td><td>10 years</td></tr></tbody></table></figure>



              <p>For more information on the individual functions that use cookies (Matomo, video portal), please consult the relevant section of this declaration.</p>



              <h3 class="font-weight-bold mt-5">4.2.2. <strong>Purpose</strong></h3>



              <p>The purpose of using the technically necessary cookies named under 4.2.1 is to simplify the use of the website for the user. Some functions of our website cannot be offered without the use of cookies. For these functions, it is necessary for the browser to be recognized when the user visits the website again later after leaving it.</p>



              <p>The purpose of each cookie is listed in the table under 4.2.1.</p>



              <p>The user data collected by the cookies are not used to create user profiles.</p>



              <p>These purposes also constitute our legitimate interest in processing personal data in accordance with § 6 para. 1 lit. f GDPR.</p>



              <h3 class="font-weight-bold mt-5">4.2.3. <strong>Legal basis</strong></h3>



              <p>The legal basis for the processing of personal data using cookies is § 6 para. 1 lit. f GDPR.</p>



              <h3 class="font-weight-bold mt-5">4.2.4. <strong>Recipient</strong></h3>



              <p>The recipient of the information contained in the cookies is exclusively the authorized web server, i.e., the university web server that sent the cookie.</p>



              <h3 class="font-weight-bold mt-5">4.2.5. <strong>Duration of data retention</strong></h3>



              <p>The cookies are retained for the periods listed in the table under 4.2.1.</p>



              <p>Since the cookies are stored on your computer, you also have the possibility of deleting them earlier. For more information, please read the following section.</p>



              <h3 class="font-weight-bold mt-5">4.2.6. <strong>Consequences of nondisclosure, possibility of objection or removal</strong></h3>



              <p>Cookies are stored on the user’s computer and transmitted to our site from it. As the user, you therefore also have complete control over the use of cookies – irrespective of the retention periods listed above. You can deactivate or limit the transfer of cookies by changing the settings of your web browser. You can also delete already stored cookies at any time. You can even set your browser to do this automatically. If you deactivate cookies for our website, you may no longer be able to use all functions of the website to their full extent.</p>



              <h3 class="font-weight-bold mt-5">4.3. <strong>Use of Matomo</strong></h3>



              <p>We use Matomo on our website to analyze the usage behavior of our visitors. Matomo collects data on things like the referrer website a particular user accessed before visiting our website, the subpages of the website the user visits, the amount of time the user spends on a web page, or how often the user visits the page.</p>



              <p>The IP address you use to access our website is anonymized. Matomo is configured to mask two bytes of the IP address (e.g.: 192.168.xxx.xxx). This makes it impossible to associate the IP address with the device used to access the site.</p>



              <p>Matomo is still set to not send any cookies for the analysis of website usage.</p>



              <p>The usage information collected by Matomo is stored exclusively on University of Freiburg servers. The stored usage data are not passed on to third parties. They are not combined with data collected from other pages requiring a disclosure of personal data.</p>



              <p>The analysis of the usage behavior of our visitors helps us to optimize our website and make it more user-friendly. This constitutes our legitimate interest in processing data in accordance with § 6 para. 1 lit. f GDPR.<br>By anonymizing the IP address, we take into sufficient account the interest of the users in protecting their personal data.</p>



              <p>Furthermore, we offer users of our website the possibility to opt out of the web analytics procedure. In this case, Matomo stores a cookie on your system that tells it to not collect any usage data. This cookie is not used for the analysis of website usage. Note: If you delete all of your cookies, you will have to reactivate the opt-out cookie.</p>



              <p>For more information configuring privacy settings in Matomo, please click on the following link: <a href="https://matomo.org/docs/privacy" target="_blank" rel="noreferrer noopener">https://matomo.org/docs/privacy</a></p>



              <h3 class="font-weight-bold mt-5">4.3.1. <strong>Description and categories of data</strong></h3>



              <p>The following data are stored when a user visits individual pages of our website:</p>



              <ol><li>two bytes of the IP address of the user’s system (The software is configured to not store the complete IP addresses but to mask two bytes of the IP address [e.g.: 192.168.xxx.xxx]. This makes it impossible to associate the IP address with the device used to access the site.)</li><li>the web page visited</li><li>the website accessed before visiting our website (referrer).</li><li>The subpages accessed from the web page visited</li><li>the duration of the visit</li><li>how often the web page is accessed</li></ol>



              <p>The software runs exclusively on the university’s servers. User data are stored exclusively on our servers. The data are not passed on to third parties.<br>Personal data are temporarily processed only inasmuch as the complete IP address is processed in volatile memory prior to being stored on the server.</p>



              <h3 class="font-weight-bold mt-5">4.3.2. <strong>Purpose</strong></h3>



              <p>The processing of the user’s personal data enables us to analyze the usage behavior of our users. An analysis of the data thus obtained allows us to collect information on the use of individual components of our website. This helps us to continually improve our website and make it more user-friendly. This also constitutes our legitimate interest in processing data in accordance with § 6 para. 1 lit. f GDPR. By anonymizing the IP address and avoiding cookies, we take into sufficient account the interest of the users in protecting their personal data.</p>



              <h3 class="font-weight-bold mt-5">4.3.3. <strong>Legal basis</strong></h3>



              <p>The legal basis for the retention of the shortened IP address and the temporary processing of the personal data of users is § 6 para. 1 lit. f GDPR.</p>



              <h3 class="font-weight-bold mt-5">4.3.4. <strong>Recipient</strong></h3>



              <p>As no personal data are collected, there is no recipient for them.</p>



              <h3 class="font-weight-bold mt-5">4.3.5. <strong>Duration of data retention</strong></h3>



              <p>No personal data is retained permanently.</p>



              <h3 class="font-weight-bold mt-5">4.3.6. <strong>Consequences of nondisclosure, possibility of objection or removal</strong></h3>



              <p>Our website observes the “do not track” setting on your browser. If your browser does not offer a “do not track” setting and you do not wish to have your access data retained and analyzed by Matomo, click on the following link to have the Matomo deactivation cookie placed on your browser.<br>Your current status:</p>



              <iframe style="border: 0; height: 150px; width: 100%;" src="https://piwik.mw.uni-freiburg.de/central/index.php?module=CoreAdminHome&amp;action=optOut&amp;idsite=22&amp;language=en"></iframe>



              <p>Warning: As a result of deleting your cookies, the opt-out cookie is also deleted and might have to be reactivated. </p>



              <h3 class="font-weight-bold mt-5">4.4. <strong>VIMP / University of Freiburg video portal</strong></h3>



              <h3 class="font-weight-bold mt-5">4.4.1. <strong>Description and categories of data</strong></h3>



              <p>Videos from the University of Freiburg’s video portal are integrated into our website and shown with a player. When you visit a page with a video integrated into it, the cookies named in 4.1. are used.</p>



              <h3 class="font-weight-bold mt-5">4.4.2. <strong>Purpose</strong></h3>



              <p>Our web pages should provide you with the necessary information and create a pleasant media experience. This also includes the integration of videos.<br>This purpose also constitutes our legitimate interest in processing data in accordance with § 6 para. 1 lit. f GDPR.</p>



              <h3 class="font-weight-bold mt-5">4.4.3. <strong>Legal basis</strong></h3>



              <p>The legal basis for the processing of personal user data is § 6 para. 1 lit. f GDPR.</p>



              <h3 class="font-weight-bold mt-5">4.4.4. <strong>Recipient</strong></h3>



              <p>The data are used by the server that places the cookie, video.uni-freiburg.de.</p>



              <h3 class="font-weight-bold mt-5">4.4.5. <strong>Duration of data retention</strong></h3>



              <p>See 4.1.</p>



              <h3 class="font-weight-bold mt-5">4.4.6. <strong>Consequences of nondisclosure, possibility of objection or removal</strong></h3>



              <p>If you do not wish to use videos from the university’s video portal, you can avoid using the web pages with integrated videos.</p>



              <h3 class="font-weight-bold mt-5">4.5. Privacy policies for social media</h3>



              <ul><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/facebook">Facebook</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/twitter">Twitter</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/instagram">Instagram</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/youtube">Youtube</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/xing">Xing</a></li><li><a href="https://www.uni-freiburg.de/datenschutz-socialmedia/linkedin">LinkedIn</a></li></ul>



              <h3 class="font-weight-bold mt-5">5. <strong>Your rights</strong></h3>



              <p>You have the right to receive information from the University of Freiburg on your personal data that has been retained and/or to have retained data that is incorrect corrected.</p>



              <p>You also have the right to demand that your data be deleted or that the processing thereof be restricted as well as to object to the processing of your data.</p>



              <p>If you have given us your consent to process your personal data, you also have the right to withdraw your consent at any time. The legality of any processing performed on the grounds of the consent prior to its withdrawal remains unaffected by the withdrawal of consent. For more information, please contact us at <a href="mailto:datenschutzbeauftragter@uni-freiburg.de">datenschutzbeauftragter@uni-freiburg.de</a>. If the processing of data is based on consent or on a formal agreement, we will refer you to the proper authority.</p>



              <p>If the data is also processed in automated form, you may have a right to data portability (§ 20 EU-GDPR).</p>



              <p>You have the right to file a complaint with the regulating authority if you believe that the processing of your personal data is in violation of the law. An example of such a regulating authority is <a href="https://www.baden-wuerttemberg.datenschutz.de/" target="_blank" rel="noreferrer noopener">Baden-Württemberg’s state commissioner for data protection and freedom of information</a> (Landesbeauftragte für den Datenschutz und die Informationsfreiheit).</p>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
name: "Datenschutz",
  data(){
    return{
      lang: String
    }
  },
  mounted() {
    this.lang = this.$store.getters.lang;
  }
}
</script>

<style scoped>
  ul{
    padding-left: 20px;
  }
</style>